// src/config/themes.js — single source of truth for all theme tokens and compositions

const MONDRIAN_BLACK = '#1A1A2E'

// ─── MONDRIAN MODULE COMPOSITIONS ────────────────────────────────────────────
// Each module gets a unique SVG composition referencing De Stijl block geometry.
// These render as background SVGs at full opacity — they ARE the background.
// The UI chrome (cards, text, borders) sits on top via z-index.

export const MONDRIAN_MODULES = {
  dashboard: {
    accent: '#FF6B00',
    bodyBg: '#FFF0DC',
    statColors: ['#FF6B00', '#FFD700', '#FFFFFF'],
    badgeColors: [
      { bg: '#FFD700', text: '#1A1A2E' },
      { bg: '#0057A8', text: '#FFFFFF' },
      { bg: '#E8272A', text: '#FFFFFF' },
    ],
    composition: `
      <rect x="0" y="0" width="160" height="110" fill="#FF6B00"/>
      <rect x="160" y="0" width="4" height="260" fill="${MONDRIAN_BLACK}"/>
      <rect x="0" y="110" width="160" height="4" fill="${MONDRIAN_BLACK}"/>
      <rect x="0" y="114" width="90" height="146" fill="#FFD700"/>
      <rect x="90" y="114" width="4" height="146" fill="${MONDRIAN_BLACK}"/>
      <rect x="94" y="114" width="66" height="146" fill="#FFFFFF"/>
      <rect x="164" y="180" width="216" height="4" fill="${MONDRIAN_BLACK}"/>
      <rect x="164" y="184" width="216" height="76" fill="#FFFFFF"/>
      <rect x="164" y="0" width="216" height="180" fill="#FFFFFF"/>
      <rect x="300" y="0" width="4" height="180" fill="${MONDRIAN_BLACK}"/>
      <rect x="304" y="0" width="76" height="80" fill="#0057A8"/>
      <rect x="304" y="80" width="76" height="4" fill="${MONDRIAN_BLACK}"/>
    `,
  },
  contacts: {
    accent: '#FFD700',
    bodyBg: '#FFFBE6',
    statColors: ['#FFD700', '#FFFFFF', '#FF6B00'],
    badgeColors: [
      { bg: '#FFD700', text: '#1A1A2E' },
      { bg: '#FF6B00', text: '#FFFFFF' },
      { bg: '#E8272A', text: '#FFFFFF' },
    ],
    composition: `
      <rect x="0" y="0" width="380" height="70" fill="#FFD700"/>
      <rect x="0" y="70" width="380" height="4" fill="${MONDRIAN_BLACK}"/>
      <rect x="0" y="74" width="200" height="186" fill="#FFFFFF"/>
      <rect x="200" y="74" width="4" height="186" fill="${MONDRIAN_BLACK}"/>
      <rect x="204" y="74" width="176" height="90" fill="#E8272A"/>
      <rect x="204" y="164" width="176" height="4" fill="${MONDRIAN_BLACK}"/>
      <rect x="204" y="168" width="176" height="92" fill="#FFFFFF"/>
      <rect x="90" y="74" width="4" height="186" fill="${MONDRIAN_BLACK}"/>
      <rect x="0" y="160" width="90" height="4" fill="${MONDRIAN_BLACK}"/>
      <rect x="0" y="164" width="90" height="96" fill="#0057A8"/>
    `,
  },
  deals: {
    accent: '#E8272A',
    bodyBg: '#FFF0EE',
    statColors: ['#E8272A', '#FFFFFF', '#FFD700'],
    badgeColors: [
      { bg: '#E8272A', text: '#FFFFFF' },
      { bg: '#FFD700', text: '#1A1A2E' },
      { bg: '#0057A8', text: '#FFFFFF' },
    ],
    composition: `
      <rect x="0" y="0" width="80" height="260" fill="#E8272A"/>
      <rect x="80" y="0" width="4" height="260" fill="${MONDRIAN_BLACK}"/>
      <rect x="84" y="0" width="296" height="140" fill="#FFFFFF"/>
      <rect x="84" y="140" width="296" height="4" fill="${MONDRIAN_BLACK}"/>
      <rect x="84" y="144" width="150" height="116" fill="#FFFFFF"/>
      <rect x="234" y="144" width="4" height="116" fill="${MONDRIAN_BLACK}"/>
      <rect x="238" y="144" width="142" height="116" fill="#FFD700"/>
      <rect x="280" y="0" width="4" height="140" fill="${MONDRIAN_BLACK}"/>
      <rect x="284" y="0" width="96" height="60" fill="#0057A8"/>
      <rect x="284" y="60" width="96" height="4" fill="${MONDRIAN_BLACK}"/>
    `,
  },
  projects: {
    accent: '#0057A8',
    bodyBg: '#EEF6FF',
    statColors: ['#0057A8', '#FFD700', '#FFFFFF'],
    badgeColors: [
      { bg: '#0057A8', text: '#FFFFFF' },
      { bg: '#FFD700', text: '#1A1A2E' },
      { bg: '#00A651', text: '#FFFFFF' },
    ],
    composition: `
      <rect x="0" y="0" width="380" height="260" fill="#FFFFFF"/>
      <rect x="240" y="0" width="140" height="160" fill="#0057A8"/>
      <rect x="236" y="0" width="4" height="260" fill="${MONDRIAN_BLACK}"/>
      <rect x="240" y="160" width="140" height="4" fill="${MONDRIAN_BLACK}"/>
      <rect x="0" y="180" width="236" height="4" fill="${MONDRIAN_BLACK}"/>
      <rect x="0" y="184" width="100" height="76" fill="#FFD700"/>
      <rect x="100" y="184" width="4" height="76" fill="${MONDRIAN_BLACK}"/>
      <rect x="104" y="184" width="132" height="76" fill="#FFFFFF"/>
      <rect x="0" y="0" width="100" height="80" fill="#E8272A"/>
      <rect x="100" y="0" width="4" height="180" fill="${MONDRIAN_BLACK}"/>
      <rect x="0" y="80" width="100" height="4" fill="${MONDRIAN_BLACK}"/>
      <rect x="104" y="0" width="132" height="180" fill="#FFFFFF"/>
    `,
  },
  finance: {
    accent: '#00A651',
    bodyBg: '#F0FFF4',
    statColors: ['#00A651', '#FFFFFF', '#0057A8'],
    badgeColors: [
      { bg: '#00A651', text: '#FFFFFF' },
      { bg: '#FFD700', text: '#1A1A2E' },
      { bg: '#0057A8', text: '#FFFFFF' },
    ],
    composition: `
      <rect x="0" y="0" width="380" height="260" fill="#FFFFFF"/>
      <rect x="0" y="0" width="70" height="130" fill="#00A651"/>
      <rect x="70" y="0" width="4" height="130" fill="${MONDRIAN_BLACK}"/>
      <rect x="0" y="130" width="4" height="130" fill="${MONDRIAN_BLACK}"/>
      <rect x="0" y="130" width="180" height="4" fill="${MONDRIAN_BLACK}"/>
      <rect x="0" y="134" width="180" height="126" fill="#FFD700"/>
      <rect x="180" y="0" width="4" height="260" fill="${MONDRIAN_BLACK}"/>
      <rect x="184" y="100" width="196" height="4" fill="${MONDRIAN_BLACK}"/>
      <rect x="184" y="0" width="196" height="100" fill="#0057A8"/>
      <rect x="300" y="104" width="4" height="156" fill="${MONDRIAN_BLACK}"/>
      <rect x="304" y="180" width="76" height="4" fill="${MONDRIAN_BLACK}"/>
      <rect x="304" y="184" width="76" height="76" fill="#E8272A"/>
    `,
  },
  productions: {
    accent: '#E8272A',
    bodyBg: '#FFF0F6',
    statColors: ['#E8272A', '#0057A8', '#FFD700'],
    badgeColors: [
      { bg: '#E8272A', text: '#FFFFFF' },
      { bg: '#0057A8', text: '#FFFFFF' },
      { bg: '#FFD700', text: '#1A1A2E' },
    ],
    composition: `
      <rect x="0" y="0" width="380" height="260" fill="#FFFFFF"/>
      <rect x="0" y="0" width="120" height="260" fill="#E8272A"/>
      <rect x="120" y="0" width="4" height="260" fill="${MONDRIAN_BLACK}"/>
      <rect x="260" y="0" width="4" height="260" fill="${MONDRIAN_BLACK}"/>
      <rect x="264" y="0" width="116" height="260" fill="#0057A8"/>
      <rect x="124" y="120" width="136" height="4" fill="${MONDRIAN_BLACK}"/>
      <rect x="124" y="124" width="136" height="136" fill="#FFD700"/>
      <rect x="190" y="0" width="4" height="120" fill="${MONDRIAN_BLACK}"/>
      <rect x="124" y="60" width="66" height="4" fill="${MONDRIAN_BLACK}"/>
      <rect x="194" y="40" width="70" height="4" fill="${MONDRIAN_BLACK}"/>
    `,
  },
  default: {
    accent: '#FF6B00',
    bodyBg: '#FFF0DC',
    statColors: ['#FF6B00', '#FFD700', '#FFFFFF'],
    badgeColors: [
      { bg: '#FFD700', text: '#1A1A2E' },
      { bg: '#0057A8', text: '#FFFFFF' },
      { bg: '#E8272A', text: '#FFFFFF' },
    ],
    composition: `<rect x="0" y="0" width="380" height="260" fill="#FFF0DC"/>`,
  },
}

// ─── ROTHKO MODULE FIELDS ─────────────────────────────────────────────────────
// Each module is a warm Rothko Color Field — deep but warm mid-dark hues, NOT near-black.
// Motherwell forms have per-form color + opacity + blur for soft diffused edges.
// A radial vignette glows inward from the perimeter (Rothko's luminous edge quality).
// Background transitions at 1.4s ease — slow bleed between modules.

export const ROTHKO_MODULES = {
  dashboard: {
    // Burnt sienna — Rothko "Ochre and Red on Red" palette
    bg: '#5C2810',
    accent: '#E86818',
    perimeterColor: '#E86818',
    forms: [
      { type: 'ellipse', cx: 310, cy: 90,  rx: 100, ry: 140, color: '#1A0804', opacity: 0.42 },
      { type: 'ellipse', cx: 70,  cy: 210, rx: 75,  ry: 100, color: '#1A0804', opacity: 0.32 },
      { type: 'rect',   x: 185,  y: 0,    w: 12,   h: 260,  color: '#1A0804', opacity: 0.38, sharp: true },
    ],
  },
  contacts: {
    // Deep warm plum — Rothko "Purple, White and Red"
    bg: '#3C1428',
    accent: '#C44068',
    perimeterColor: '#C44068',
    forms: [
      { type: 'ellipse', cx: 80,  cy: 190, rx: 90,  ry: 120, color: '#140810', opacity: 0.42 },
      { type: 'ellipse', cx: 300, cy: 60,  rx: 70,  ry: 95,  color: '#140810', opacity: 0.35 },
      { type: 'rect',   x: 178,  y: 0,    w: 10,   h: 260,  color: '#140810', opacity: 0.38, sharp: true },
    ],
  },
  deals: {
    // Deep crimson — Rothko "Orange and Red on Red"
    bg: '#5C1818',
    accent: '#E83018',
    perimeterColor: '#E83018',
    forms: [
      { type: 'ellipse', cx: 300, cy: 130, rx: 110, ry: 150, color: '#180404', opacity: 0.44 },
      { type: 'rect',   x: 190,  y: 0,    w: 12,   h: 260,  color: '#180404', opacity: 0.40, sharp: true },
    ],
  },
  projects: {
    // Deep warm forest — Rothko earth-green tones
    bg: '#1E3A1A',
    accent: '#508040',
    perimeterColor: '#508040',
    forms: [
      { type: 'ellipse', cx: 60,  cy: 60,  rx: 80,  ry: 110, color: '#0A180A', opacity: 0.40 },
      { type: 'ellipse', cx: 300, cy: 200, rx: 75,  ry: 100, color: '#0A180A', opacity: 0.33 },
      { type: 'rect',   x: 178,  y: 0,    w: 10,   h: 260,  color: '#0A180A', opacity: 0.38, sharp: true },
    ],
  },
  finance: {
    // Deep warm amber/umber — Rothko ochre series
    bg: '#4A3010',
    accent: '#D4881A',
    perimeterColor: '#D4881A',
    forms: [
      { type: 'ellipse', cx: 80,  cy: 120, rx: 85,  ry: 115, color: '#180E04', opacity: 0.42 },
      { type: 'ellipse', cx: 300, cy: 70,  rx: 70,  ry: 95,  color: '#180E04', opacity: 0.35 },
      { type: 'rect',   x: 180,  y: 0,    w: 10,   h: 260,  color: '#180E04', opacity: 0.38, sharp: true },
    ],
  },
  productions: {
    // Deep warm burgundy-rose — Rothko magenta palette
    bg: '#3A1028',
    accent: '#C03060',
    perimeterColor: '#C03060',
    forms: [
      { type: 'ellipse', cx: 190, cy: 40,  rx: 120, ry: 60,  color: '#14060E', opacity: 0.42 },
      { type: 'ellipse', cx: 190, cy: 220, rx: 100, ry: 55,  color: '#14060E', opacity: 0.35 },
    ],
  },
  default: {
    bg: '#5C2810',
    accent: '#E86818',
    perimeterColor: '#E86818',
    forms: [
      { type: 'ellipse', cx: 290, cy: 130, rx: 95,  ry: 130, color: '#1A0804', opacity: 0.40 },
    ],
  },
}

// ─── THEME METADATA ───────────────────────────────────────────────────────────

// Division colors surface on records/badges by company_id — not as separate themes.
// chatrone_us  → teal  (#3DD5CF) for Management, orange (#F5722A) for Production context
// chatrone_latam → coral (#E85B40)

export const THEMES = {
  // ── Block system (default) ────────────────────────────────────────────────
  blocks: {
    id: 'blocks',
    label: 'Blocks',
    description: 'Color-coded by Block. Each section owns a hue.',
    previewColor: '#BA7517',
    previewAccent: '#2D6FB8',
  },
  // ── Chatrone brand themes ─────────────────────────────────────────────────
  chatrone: {
    id: 'chatrone',
    label: 'Chatrone',
    description: 'Brand standard. Clean and professional.',
    previewColor: '#2D3E4E',
    previewAccent: '#3DD5CF',
  },
  'chatrone-dark': {
    id: 'chatrone-dark',
    label: 'Chatrone Dark',
    description: 'Dark mode. Same brand, late nights.',
    previewColor: '#0C141E',
    previewAccent: '#3DD5CF',
  },
  // ── Classic themes ────────────────────────────────────────────────────────
  midnight: {
    id: 'midnight',
    label: 'Midnight',
    description: 'Deep navy.',
    previewColor: '#0F1322',
    previewAccent: '#3A6FD8',
  },
  mondrian: {
    id: 'mondrian',
    label: 'Mondrian',
    description: 'De Stijl grid.',
    previewColor: '#FF6B00',
    previewAccent: '#FFD700',
    blackLine: '#1A1A2E',
  },
  rothko: {
    id: 'rothko',
    label: 'Rothko / Motherwell',
    description: 'Color Field.',
    previewColor: '#5C2810',
    previewAccent: '#E86818',
    bgTransition: 'background 1.4s ease',
    motherwellOpacity: 0.40,
  },
}

// Division accent color lookup — used for company badges and entity-specific UI
export const DIVISION_ACCENT = {
  chatrone_us:    '#3DD5CF',  // Chatrone US — teal
  chatrone_latam: '#E85B40',  // Chatrone LatAm — coral
}
export const DIVISION_LABEL = {
  chatrone_us:    'US',
  chatrone_latam: 'LatAm',
}

// ─── ROUTE → MODULE MAP ───────────────────────────────────────────────────────

export const ROUTE_TO_MODULE = {
  '/dashboard': 'dashboard',
  '/contacts': 'contacts',
  '/companies': 'contacts',
  '/clients': 'contacts',
  '/comms': 'contacts',
  '/deals': 'deals',
  '/opportunities': 'deals',
  '/projects': 'projects',
  '/properties': 'projects',
  '/files': 'projects',
  '/intelligence': 'projects',
  '/finance': 'finance',
  '/reports': 'finance',
  '/inbox': 'productions',
  '/tasks': 'productions',
  '/calendar': 'productions',
  '/settings': 'default',
  '/engineering': 'default',
  '/janet': 'default',
  '/admin': 'default',
  '/': 'dashboard',
}

export function getModuleFromPath(pathname) {
  const match = Object.keys(ROUTE_TO_MODULE)
    .sort((a, b) => b.length - a.length) // longest prefix first
    .find(prefix => pathname === prefix || pathname.startsWith(prefix + '/'))
  return ROUTE_TO_MODULE[match] || 'default'
}

// ─── BLOCKS ───────────────────────────────────────────────────────────────────
// The Block layer is the always-on information architecture: every surface in the
// OS belongs to exactly one color-coded Block. The `blocks` theme paints each page
// with its Block's tint (full-page chrome) and the sidebar groups nav by Block.
//
// Redundancy is intentional: Deals has its own Block AND appears under Clients,
// Properties and Finance; Opportunities and Submissions live in BOTH Management and
// Production. The underlying record is the same — the Block is just the doorway you
// walked through, and for Deals the doorway decides the default filter (Clients →
// management deals, Properties → production deals, the Deals Block → all of them).
// `ROUTE_TO_BLOCK` below picks the single *canonical* Block used for page chrome
// when a route is shared.
//
// Token meanings:
//   accent     — active nav item + page accent line (strong, ~600 stop)
//   bodyBg     — full-page background tint (very light, keeps body text readable)
//   labelColor — the Block's uppercase section header in the sidebar
//   railTint   — faint sidebar group background so blocks read as distinct bands

export const BLOCKS = {
  universal: {
    id: 'universal',
    label: 'Universal',
    accent: '#E0582F',
    bodyBg: '#FCF4EF',
    labelColor: '#9C3A16',
    railTint: 'rgba(224,88,47,0.06)',
    // The always-on top bar (UniversalBar) — coral→amber sunset, not gray.
    barGradient: 'linear-gradient(90deg, #E0582F 0%, #E8823A 55%, #EFA53E 100%)',
  },
  management: {
    id: 'management',
    label: 'Management',
    accent: '#BA7517',
    bodyBg: '#FBF4E6',
    labelColor: '#854F0B',
    railTint: 'rgba(186,117,23,0.07)',
  },
  production: {
    id: 'production',
    label: 'Production',
    accent: '#2D6FB8',
    bodyBg: '#EEF5FC',
    labelColor: '#0C447C',
    railTint: 'rgba(45,111,184,0.07)',
  },
  deals: {
    id: 'deals',
    label: 'Deals',
    accent: '#A8324A',
    bodyBg: '#FCEFF2',
    labelColor: '#761C31',
    railTint: 'rgba(168,50,74,0.07)',
  },
  finance: {
    id: 'finance',
    label: 'Finance',
    accent: '#4E8C2B',
    bodyBg: '#F1F8EA',
    labelColor: '#27500A',
    railTint: 'rgba(78,140,43,0.07)',
  },
  directory: {
    id: 'directory',
    label: 'Directory',
    accent: '#6A5FB8',
    bodyBg: '#F3F1FB',
    labelColor: '#3C3489',
    railTint: 'rgba(106,95,184,0.07)',
  },
  research: {
    id: 'research',
    label: 'Research',
    accent: '#1D9E75',
    bodyBg: '#EAF6F1',
    labelColor: '#085041',
    railTint: 'rgba(29,158,117,0.07)',
  },
  engineering: {
    id: 'engineering',
    label: 'Engineering',
    accent: '#2F6F89',
    bodyBg: '#EDF7FA',
    labelColor: '#18495D',
    railTint: 'rgba(47,111,137,0.07)',
  },
  system: {
    id: 'system',
    label: 'System',
    accent: '#6B6B68',
    bodyBg: '#F4F4F2',
    labelColor: '#444441',
    railTint: 'rgba(68,68,65,0.05)',
  },
  default: {
    id: 'default',
    label: '',
    accent: '#6B7280',
    bodyBg: '#F6F5F1',
    labelColor: '#5F5E5A',
    railTint: 'transparent',
  },
}

// Route → canonical Block (drives page chrome). Longest-prefix match, so detail
// routes (/clients/:id, /projects/:id, /deals/:id) inherit their parent Block.
export const ROUTE_TO_BLOCK = {
  '/': 'universal',
  '/inbox': 'universal',
  '/messages': 'universal',
  '/comms': 'universal',
  '/tasks': 'universal',
  '/calendar': 'universal',
  '/activity': 'universal',
  '/janet': 'universal',

  '/clients': 'management',
  '/properties': 'production', // the registry lives in the merged Production block; the Clients tab pins ?block=management
  '/submissions': 'management',
  '/opportunities': 'management',
  '/deals': 'deals', // Deals has its own doorway; also surfaced in Clients/Properties/Finance navs

  '/projects': 'production',
  '/console': 'production', // brainstorm rooms + writers' rooms open inside Chatrone, beside the work they serve
  '/studio': 'production', // hub, design takes, and the Chatrone Studio embed all live in Production now

  '/finance': 'finance',
  '/reports': 'finance',

  '/contacts': 'directory',
  '/companies': 'directory',

  '/research': 'research',
  '/audience': 'research',

  '/engineering': 'engineering',

  '/files': 'system',
  '/settings': 'system',
  '/admin': 'system',
}

export function getBlockFromPath(pathname, search = '') {
  // An explicit ?block= pin wins — lets a route shared across Blocks (Deals,
  // Opportunities, Submissions) stay in whichever Block doorway you came through.
  if (search) {
    try {
      const pinned = new URLSearchParams(search).get('block')
      if (pinned && BLOCKS[pinned]) return pinned
    } catch { /* ignore malformed search */ }
  }
  const match = Object.keys(ROUTE_TO_BLOCK)
    .sort((a, b) => b.length - a.length) // longest prefix first
    .find(prefix => pathname === prefix || pathname.startsWith(prefix + '/'))
  return ROUTE_TO_BLOCK[match] || 'universal'
}

// ─── BLOCK NAV ──────────────────────────────────────────────────────────────
// Two-level navigation: the left rail shows one entry per Block (BLOCK_ORDER);
// clicking opens that Block's `landing` page, and BlockTabBar renders its `tabs`
// across the top. Shared routes carry ?block= so the doorway is preserved, and
// ?view= so the page lands pre-filtered (Opportunities, Submissions).
//
// Universal is NOT in the desktop rail — its tabs (Dashboard, Inbox, Messages,
// Tasks, Comms, Calendar) live in the always-visible UniversalBar at the top,
// reachable from any Block. Mobile still shows it in the bottom nav.
export const BLOCK_ORDER = ['universal', 'directory', 'management', 'production', 'deals', 'finance', 'research', 'engineering', 'system']
export const RAIL_BLOCK_ORDER = BLOCK_ORDER.filter(id => id !== 'universal')

export const BLOCK_NAV = {
  universal: {
    label: 'Universal', landing: '/',
    tabs: [
      { labelKey: 'nav.dashboard',  path: '/' },
      { labelKey: 'nav.inbox',      path: '/inbox' },
      { labelKey: 'nav.janetChat',  path: '/janet/chat' },
      { labelKey: 'nav.janetQueue', path: '/janet/queue' },
      { labelKey: 'nav.messages',   path: '/messages' },
      { labelKey: 'nav.tasks',     path: '/tasks' },
      { labelKey: 'nav.comms',     path: '/comms' },
      { labelKey: 'nav.calendar',  path: '/calendar' },
    ],
  },
  directory: {
    label: 'Directory', landing: '/contacts',
    tabs: [
      { labelKey: 'nav.contacts',  path: '/contacts' },
      { labelKey: 'nav.companies', path: '/companies' },
    ],
  },
  management: {
    label: 'Clients', landing: '/clients',
    tabs: [
      { labelKey: 'nav.clients',       path: '/clients' },
      { labelKey: 'nav.properties',    path: '/properties?block=management' },
      { labelKey: 'nav.deals',         path: '/deals?block=management' },
      { labelKey: 'nav.submissions',   path: '/submissions?view=management&block=management' },
      { labelKey: 'nav.opportunities', path: '/opportunities?view=management&block=management' },
    ],
  },
  production: {
    // The merged Production block (2026-08-13, absorbed the Studio block):
    // the one path through the registry of what exists AND the gateway to
    // creating new work. Lands on the slate — the zoom paradigm's root.
    label: 'Production', landing: '/studio/hub',
    // Design takes, deals, the Chatrone Studio embed, and the Creative Console
    // are NOT top tabs: they only mean something attached to the work, so they
    // are reached THROUGH it (Property → Design/Deals/Pathways, Expression →
    // Creative/Business/Stages, the per-row Console door). Destination-first
    // doors are the old geography (Aaron, 2026-08-13). /studio and
    // /studio/design still route for bookmarks.
    tabs: [
      { labelKey: 'nav.slate',          path: '/studio/hub' },
      { labelKey: 'nav.properties',     path: '/properties' },
      { labelKey: 'nav.projects',       path: '/projects' },
      { labelKey: 'nav.opportunities',  path: '/opportunities?view=production&block=production' },
      { labelKey: 'nav.submissions',    path: '/submissions?view=production&block=production' },
    ],
  },
  deals: {
    // The unfiltered doorway: every deal, management and production side by side.
    // The Clients / Properties tabs land pre-scoped; this one deliberately does not.
    label: 'Deals', landing: '/deals?block=deals',
    tabs: [
      { labelKey: 'nav.deals',         path: '/deals?block=deals' },
      { labelKey: 'nav.opportunities', path: '/opportunities?block=deals' },
    ],
  },
  finance: {
    label: 'Finance', landing: '/finance',
    tabs: [
      { labelKey: 'nav.finance', path: '/finance' },
      { labelKey: 'nav.deals',   path: '/deals?block=finance' },
      { labelKey: 'nav.reports', path: '/reports' },
    ],
  },
  research: {
    label: 'Research', landing: '/research',
    tabs: [
      { labelKey: 'nav.research', path: '/research' },
      { labelKey: 'nav.audience', path: '/audience' },
    ],
  },
  engineering: {
    label: 'Engineering', landing: '/engineering',
    tabs: [
      { labelKey: 'nav.engineering', path: '/engineering' },
    ],
  },
  system: {
    label: 'System', landing: '/files',
    tabs: [
      { labelKey: 'nav.files',    path: '/files' },
      { labelKey: 'nav.settings', path: '/settings' },
    ],
  },
}
